export default __webpack_public_path__ + "static/thumbnail-E-Verify-7c55c70557e30db0bf40ad2434220aff.png";